export default "__VITE_ASSET__CNwK_3c8__"